import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { CompanyDefaultsSubTabs } from "../components/common/CompanyDefaultsSubTabs.tsx"
import { SettingsTemplatesHub } from "../components/settings-templates/SettingsTemplatesHub.tsx"

export default function SettingsTemplatesPage() {
  useEffect(() => {
    generateDocumentTitle("Settings Templates")
  }, [])

  return (
    <div className="flex-1 flex flex-col w-full">
      <CompanyDefaultsSubTabs />
      <SettingsTemplatesHub />
    </div>
  )
}
